import { useEffect, useState } from 'react';
import useViewer from '@hooks/useViewer';

const useConversationUnread = conversation => {
    const [unreadCount, setUnreadCount] = useState();
    const { viewer } = useViewer();
    const lastMessageIndex = conversation?.channelState.lastMessage?.index;
    const lastReadIndex = conversation?.channelState.lastReadMessageIndex;
    const lastMessage = conversation?.channelState.lastMessage;

    useEffect(() => {
        (async () => {
            if (!conversation || !viewer) return;

            const updateUnread = async () => {
                const unread = await conversation.getUnreadMessagesCount();
                if (unread !== null) {
                    setUnreadCount(unread);
                    return;
                }

                // if null, new conversation. Manually get message count from other participant
                // because read horizon is not set
                const messages = await conversation.getMessages();
                const promises = messages.items.filter(async message => {
                    const participant = await message.getParticipant();
                    return participant.state.identity !== viewer.id;
                });
                const messagesTo = await Promise.all(promises);

                setUnreadCount(messagesTo.length);
            };

            // this is semi-realtime, so can't update immediately.
            // https://media.twiliocdn.com/sdk/js/conversations/releases/1.2.1/docs/Conversation.html#getUnreadMessagesCount__anchor
            setTimeout(async () => {
                updateUnread();
            }, 2000);
        })();
    }, [conversation, lastReadIndex, lastMessageIndex, lastMessage, viewer]);

    return unreadCount;
};

export default useConversationUnread;
